export const environment = {
  production: true,
  locale: 'en-GB',
  currency: 'GBP',
  appName: 'Inombra',
  appUrl: 'https://inombra.com',
  masterEmail: 'info@brokenblinds.co.uk',
  appBackend: {
    url: 'https://inombra.com:8000/api/v1',
    key: 'rmhYfWq9jnRQJkhCG3Nblw',
  },
  SentryDsn:
    'https://e6d1bcfb4ae14d818ed41de6e024a773@o4504514207612928.ingest.sentry.io/4504514210234369',
  AgGridLicense:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-075322}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Installshade_ltd}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_March_2026}____[v3]_[01]_MTc3Mzc5MjAwMDAwMA==05fce0e6b27388965aedc07b1bb38462',
  SyncfusionLicense:
    'Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXdfeXVURmFYVER+XENWYEE=',
  Pusher: {
    key: '8261a9af076916dd3324',
    cluster: 'eu',
  },
  Xero: {
    url: 'xero_pdf_invoice',
    viewInvoice: 'https://go.xero.com/app/!ngH7Q/invoicing/view',
  },
  QB: {
    url: 'qb_pdf_invoice',
  },
};
